import Chart from 'chart.js/auto';
import DoughnutData from '@type/sorr2025/DoughnutData';
import doughnutChartConfig from '@functions/sorr2025/chartConfigs/doughnutChartConfig';

const initializeDoughtnutChart = () => {
    const dougnutArray: DoughnutData[] = [
        {
            label: 'More productive staff',
            value: 42,
            gradients: [
                { stop: 0, color: 'rgba(231, 246, 247, 1)' },
                { stop: 1, color: 'rgba(0, 163, 173, 1)' },
            ],
        },
        {
            label: 'Increased sales',
            value: 41,
            gradients: [
                { stop: 0, color: 'rgba(231, 246, 247, 1)' },
                { stop: 1, color: 'rgba(0, 163, 173, 1)' },
            ],
        },
        {
            label: 'More efficient FOH operations',
            value: 41,
            gradients: [
                { stop: 0, color: 'rgba(231, 246, 247, 1)' },
                { stop: 1, color: 'rgba(0, 163, 173, 1)' },
            ],
        },
        {
            label: 'Business growth',
            value: 40,
            gradients: [
                { stop: 0, color: 'rgba(231, 246, 247, 1)' },
                { stop: 1, color: 'rgba(0, 75, 79, 1)' },
            ],
        },
        {
            label: 'Faster service',
            value: 37,
            gradients: [
                { stop: 0, color: 'rgba(231, 246, 247, 1)' },
                { stop: 1, color: 'rgba(0, 75, 79, 1)' },
            ],
        },
        {
            label: 'Saved time',
            value: 36,
            gradients: [
                { stop: 0, color: 'rgba(231, 246, 247, 1)' },
                { stop: 1, color: 'rgba(0, 75, 79, 1)' },
            ],
        },
        {
            label: 'Saved money',
            value: 34,
            gradients: [
                { stop: 0, color: 'rgba(231, 246, 247, 1)' },
                { stop: 1, color: 'rgba(0, 75, 79, 1)' },
            ],
        },
        {
            label: 'More efficient BOH operations',
            value: 34,
            gradients: [
                { stop: 0, color: 'rgba(231, 246, 247, 1)' },
                { stop: 1, color: 'rgba(0, 75, 79, 1)' },
            ],
        },
        {
            label: 'Happier customers',
            value: 31,
            gradients: [
                { stop: 0, color: 'rgba(231, 246, 247, 1)' },
                { stop: 1, color: 'rgba(0, 75, 79, 1)' },
            ],
        },
    ];

    dougnutArray.forEach((item, index) => {
        const canvas = document.getElementById(`chart-${index + 1}`) as HTMLCanvasElement;

        if (canvas instanceof HTMLCanvasElement) {
            const ctx = canvas.getContext('2d');

            const gradient = ctx.createLinearGradient(0, 100, 200, 87.3196);
            item.gradients.forEach((stop) => {
                gradient.addColorStop(stop.stop, stop.color);
            });

            new Chart(
                ctx,
                doughnutChartConfig({
                    data: item,
                    backgroundColor: gradient,
                })
            );
        }
    });
};

export default initializeDoughtnutChart;
